import EnvVars from './EnvVars'

const home: string = '/'
const notFound: string = '/not-found'
const dashboard: string = '/dashboard'
const accounts: string = '/accounts'
const issuers: string = '/issuers'
const opportunities: string = '/opportunities'
const orderBook: string = '/orderbook'
const holdings: string = '/holdings'
const campaigns: string = '/campaigns'
const segments: string = '/segments'
const investorLeads: string = '/investor-leads'
const lookerProofOfConcept: string = '/looker'
const deals: string = '/deals'

export const Routes = {
  // General
  home: () => home,
  dashboard: () => dashboard,
  notFound: () => notFound,
  orderBook: () => orderBook,
  holdings: () => holdings,
  campaigns: () => campaigns,
  segments: () => segments,
  investorLeads: () => investorLeads,
  lookerProofOfConcept: () => lookerProofOfConcept,

  // Primary pages
  accounts: () => accounts,
  issuers: () => issuers,
  opportunities: () => opportunities,
  account: (id: string = ':id') => `${accounts}/${id}`,
  accountOpportunities: (id: string = ':id') => `${accounts}/${id}/opportunities`,
  issuer: (id: string = ':id') => `${issuers}/${id}`,
  opportunity: (id: string = ':id') => `${opportunities}/${id}`,

  // Campaign
  campaign: (id: string = ':id') => `${campaigns}/${id}`,
  campaignForm: (id: string = ':id') => `${campaigns}/${id}/edit`,

  // Segment
  segment: (id: string = ':id') => `${segments}/${id}`,
  segmentForm: () => '/create-segment',

  // Deal
  deals: () => deals,
  deal: (id: string = ':id') => `${deals}/${id}`,
  dealOrder: (dealId: string | number = ':dealId', orderId: string | number = ':orderId') =>
    `${deals}/${dealId.toString()}/orders/${orderId.toString()}`,

  // External links
  adminEntityPage: (id: number) => `${EnvVars.ADMIN_URL}/entity-details/${id}`,
  adminCompanyPage: (id: number) => `${EnvVars.ADMIN_URL}/companies/${id}`,
  platformCompanyPage: (token: string) => `${EnvVars.APP_URL}/company/${token}`,
  platformOfferingPage: (token: string) => `${EnvVars.APP_URL}/opportunity/${token}`,
  crunchbaseCompanyPage: (crunchbaseHandle: string) => `https://www.crunchbase.com/organization/${crunchbaseHandle}`,
}

export function routeWithBaseName(fn: (...args: any[]) => string) {
  return (...args: any[]) => fn(...args)
}

export function openInNewWindow(url: string) {
  const win = window.open(url, '_blank')
  if (win) win.focus()
}

export const createValidAbsoluteLink = (link: string) => {
  if (link.startsWith('https://') || link.startsWith('http://')) {
    return link
  }
  return `//${link}`
}
